// Unpublished Work © 2021-2022 Deere & Company

import {
    RESET_SELECT_BUSINESS_CONTACT,
    SET_SELECT_BUSINESS_CONTACT_PAGE_STATUS
} from '../../action-list';
import {PageStatus} from '../../state/struct/page-status';

const setSelectBusinessContactPageStatus = (state, action) => action.pageStatus;

const resetSelectBusinessContactStatus = () => PageStatus.meta.map.COMPLETE;

export function status(state = PageStatus.meta.map.COMPLETE, action = {}) {
    const actionHandlers = {
        [SET_SELECT_BUSINESS_CONTACT_PAGE_STATUS]: setSelectBusinessContactPageStatus,
        [RESET_SELECT_BUSINESS_CONTACT]: resetSelectBusinessContactStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
